import styled from 'styled-components'
import Button from 'syf-component-library/ui/atoms/Button'
import query from 'mediaQueries'
import { colors, opacities } from 'const/colors'
import AddressContainer from 'ui/atoms/AddressContainer'

export const WelcomePanelContainer = styled.div`
  display: flex;
  padding: 20px 16px 20px 16px;
  background-color: ${colors.white};
  position: relative;
  box-shadow: 0 2px 16px 0 ${opacities.greyEightyOne};
  -webkit-box-shadow: 0 2px 16px 0 ${opacities.greyEightyOne};
  min-height: 88px;
  @media ${query.greaterThanMedium} {
    padding: 30px 20px 30px 62px;
    box-shadow: none;
    -webkit-box-shadow: none;
    min-height: 140px;
  }
`

export const AccountWrapper = styled.div`
  display: flex;
`

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  min-height: 40px;
  @media ${query.greaterThanMedium} {
    min-height: 80px;
  }
`
export const CardImage = styled.img`
  height: 38px;
  margin-right: 1rem;
  @media ${query.greaterThanMedium} {
    height: 73px;
  }
`

export const AccountDetails = styled.div`
  display: flex;
  flex-direction: column;
`

export const SwitchAccountButton = styled(Button)`
  display: none;
  @media ${query.greaterThanSmall} {
    display: block;
    font-size: 14px;
    margin-left: auto;
    align-self: center;
    background-color: ${colors.white};
    text-transform: uppercase;
  }
`

export const SwitchAccountMobileIcon = styled.button`
  border: none;
  padding: 0;
  background: none;
  position: relative;
  margin-left: auto;
  align-self: center;
  cursor: pointer;
  @media ${query.greaterThanSmall} {
    display: none;
  }
`

export const SwitchCardIcon = styled.img`
  height: 23px;
`

export const AddressDetails = styled(AddressContainer)`
  @media ${query.lessThanMedium} {
    display: none;
  }
`
